import ajax from '../utils/request'
const mediaApi = {
  /********************************标签管理*********************************** */
  // 添加标签
  addMediaTags(params) {
    return ajax({
      url: '/mediaTag/add',
      type: 'post',
      params: params
    })
  },
  // 请求标签列表
  getMediaTagList(params) {
    return ajax({
      url: '/mediaTag/list',
      type: 'get',
      params: params
    })
  },
  // 删除tags
  deleteMediaTags(params) {
    return ajax({
      url: '/mediaTag/delete',
      type: 'delete',
      params: params
    })
  },
  // 编辑标签
  editMediaTags(params) {
    return ajax({
      url: '/mediaTag/update',
      type: 'post',
      params: params
    })
  },
  /********************************标签维度管理*********************************** */
  // 添加标签
  addMediaTagDimensions(params) {
    return ajax({
      url: '/mediaTagDimension/add',
      type: 'post',
      params: params
    })
  },
  // 请求标签列表
  getMediaTagDimensionList(params) {
    return ajax({
      url: '/mediaTagDimension/list',
      type: 'get',
      params: params
    })
  },
  // 删除tags
  deleteMediaTagDimensions(params) {
    return ajax({
      url: '/mediaTagDimension/delete',
      type: 'delete',
      params: params
    })
  },
  // 编辑标签
  editMediaTagDimensions(params) {
    return ajax({
      url: '/mediaTagDimension/update',
      type: 'post',
      params: params
    })
  },
  // 获取种类下的维度
  getMediaTagDimensions(params) {
    return ajax({
      url: '/mediaTagDimension/find',
      type: 'get',
      params: params
    })
  },
  // 获取种类、维度下的标签
  getMediaTagByKindDimension(params) {
    return ajax({
      url: '/mediaTag/find',
      type: 'get',
      params: params
    })
  },
  // 校验媒体是否存在
  getMediaInfo(params) {
    return ajax({
      url: '/media/find',
      type: 'post',
      params: params
    })
  },
  //媒体上传
  // 视频上传
  uploadMedia(params) {
    return ajax({
      url: '/media/submit',
      type: 'post',
      params: params
    })
  },
  // 子媒体上传
  subUploadMedia(params) {
    return ajax({
      url: '/media/sub/submit',
      type: 'post',
      params: params
    })
  },
  // 媒体编辑
  editMediaInfo(params) {
    return ajax({
      url: '/media/update',
      type: 'post',
      params: params
    })
  },
  // 子媒体编辑
  editSubMediaInfo(params) {
    return ajax({
      url: '/media/sub/update',
      type: 'post',
      params: params
    })
  },
  // 子媒体编辑
  modifySubMediaInfo(params) {
    return ajax({
      url: '/media/sub/batch/modify',
      type: 'post',
      params: params
    })
  },
  exportMediaList(params) {
    return ajax({
      url: '/media/list/export',
      type: 'post',
      responseType: "blob",
      params: params
    })
  },
  getMediaList(params) {
    return ajax({
      url: '/media/list',
      type: 'post',
      params: params
    })
  },
  getNewTopics(params) {
    return ajax({
      url: '/module/section/list',
      type: 'post',
      params: params
    })
  },
  getSubMediaList(params) {
    return ajax({
      url: '/media/sub/list',
      type: 'get',
      params: params
    })
  },
  // 设置是否免费
  updIsFree(params) {
    return ajax({
      url: '/media/updIsFree',
      type: 'post',
      params: params
    })
  },
  // 批量删除动漫列表
  batchDelMedia(params) {
    return ajax({
      url: '/media/del',
      type: 'delete',
      params: params
    })
  },
  // 批量移除
  batchRemoveToicp(params) {
    return ajax({
      url: '/media/batch/del',
      type: 'post',
      params: params
    })
  },
  // 设置媒体状态
  setMediaStatus(params) {
    return ajax({
      url: '/media/batch/update',
      type: 'post',
      params: params
    })
  },
  // 设置子媒体状态
  setSubMediaStatus(params) {
    return ajax({
      url: '/media/sub/batch/update',
      type: 'post',
      params: params
    })
  },
  // 删除子媒体
  delSubMediaStatus(params) {
    return ajax({
      url: '/media/sub/batch/del',
      type: 'post',
      params: params
    })
  },
  /***********************acg媒体资源库************************ */
  // 查询acg媒体资源库列表
  queryAcgMediaResConfig(params) {
    return ajax({
      url: "/mediaResource/media/list",
      type: "get",
      params: params,
    });
  },
  // 查询acg媒体资源库列表(子)
  queryAcgMediaContentResConfig(params) {
    return ajax({
      url: "/mediaResource/media/content_list",
      type: "get",
      params: params,
    });
  },
  // acg媒体使用
  useAcgMediaRes(params) {
    return ajax({
      url: "/mediaResource/media/use",
      type: "post",
      params: params,
    });
  },
  // acg媒体使用
  ignoreAcgMediaRes(params) {
    return ajax({
      url: "/mediaResource/media/ignore",
      type: "post",
      params: params,
    });
  },
  // acg媒体同步
  acgMediaSync(params) {
    return ajax({
      url: "/mediaResource/media/sync",
      type: "post",
      params: params,
    });
  },
}
export default mediaApi